module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-switch@1.8.0@rc-switch/es/index.js
// module id = 760
// module chunks = 0